import Shape from './Shape';

export default class Connector extends Shape {
  #primaryKeys;

  constructor(id, position) {
    super(id, 'P', 'Connector', position);
    this.#primaryKeys = [];
  }

  addNewPrimaryKey(key) {
    this.#primaryKeys.push(key);
  }

  getPrimaryKeyAt(index) {
    return this.#primaryKeys[index];
  }

  getPrimaryKeys() {
    return this.#primaryKeys;
  }

  getSavedObject() {
    return {
      position: this.getPosition(),
      keys: this.#primaryKeys.map(key => key.getName()),
    };
  }
}
